var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHeroart4(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 602,
    height: 411,
    viewBox: "0 0 602 411",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_176_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M383.444 400.153C383.444 400.153 280.85 300.705 479.223 154.618C479.223 154.618 542.859 400.281 383.444 400.153Z",
    fill: "url(#paint0_linear_176_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.398 154.154L372.871 385.567C352.906 353.245 325.052 267.818 479.398 154.154Z",
    fill: "url(#paint1_linear_176_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.368 376.418C377.281 376.418 377.193 376.399 377.108 376.36C376.795 376.216 376.66 375.845 376.803 375.535L478.833 153.894C478.976 153.581 479.35 153.443 479.658 153.589C479.971 153.732 480.106 154.103 479.963 154.413L377.933 376.055C377.83 376.283 377.601 376.418 377.368 376.418Z",
    fill: "url(#paint2_linear_176_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.135 270.483C425.893 270.483 425.663 270.343 425.562 270.104C425.427 269.788 425.575 269.422 425.891 269.287L488.193 242.621C488.506 242.485 488.874 242.631 489.009 242.949C489.145 243.265 488.996 243.631 488.681 243.766L426.376 270.433C426.296 270.468 426.214 270.483 426.132 270.483H426.135Z",
    fill: "url(#paint3_linear_176_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.278 317.96C403.955 317.96 403.682 317.711 403.658 317.382L398.985 251.008C398.961 250.666 399.218 250.366 399.563 250.342C399.873 250.31 400.205 250.576 400.229 250.921L404.902 317.294C404.926 317.636 404.666 317.936 404.324 317.96C404.308 317.96 404.294 317.96 404.278 317.96Z",
    fill: "url(#paint4_linear_176_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M483.209 374.466C483.209 374.466 447.534 289.601 602 253.159C602 253.159 577.651 414.83 483.209 374.466Z",
    fill: "url(#paint5_linear_176_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M602 253.162L483.209 374.468C483.209 374.468 567.245 426.757 602 253.162Z",
    fill: "url(#paint6_linear_176_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.969 411C456.324 411 587.939 399.001 587.939 384.201C587.939 369.4 456.324 357.401 293.969 357.401C131.615 357.401 0 369.4 0 384.201C0 399.001 131.615 411 293.969 411Z",
    fill: "url(#paint7_linear_176_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.1573 169.101C55.1573 169.101 48.8614 174.99 44.6764 230.679L37.7943 229.665C37.7943 229.665 33.6465 180.16 40.2236 160.727C46.8007 141.294 55.1573 169.098 55.1573 169.098V169.101Z",
    fill: "#FFCDC4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.582 124.333C102.582 124.333 103.452 124.787 104.926 125.521C111.238 128.675 128.604 137.047 135.873 137.41C144.839 137.859 169.053 104.16 169.053 104.16L176.675 108.73C176.675 108.73 156.05 152.212 135.873 151.315C115.696 150.419 98.4922 144.098 98.4922 144.098L102.582 124.336V124.333Z",
    fill: "#FFCDC4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M529.493 361.593L528.167 344.762L540.823 345.804L539.963 363.372C539.963 363.372 532.066 364.282 529.493 361.593Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M540.109 361.38C540.109 361.38 535.945 363.017 529.495 361.593C529.495 361.593 510.618 368.306 510.867 373.903C510.867 373.903 509.934 375.508 518.404 375.675C526.875 375.842 540.029 376.283 540.395 376.11C540.759 375.938 544.108 373.956 540.109 361.383V361.38Z",
    fill: "#121729"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M540.396 376.108C540.032 376.28 526.878 375.84 518.405 375.673C509.934 375.505 510.865 373.901 510.865 373.901C510.849 373.532 510.921 373.158 511.059 372.779L541.987 372.633C541.714 375.349 540.592 376.009 540.39 376.108H540.396Z",
    fill: "#83CAF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.276 361.592L482.347 343.926L494.801 346.149L489.41 362.481C489.41 362.481 481.849 364.282 479.276 361.592Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M489.892 361.38C489.892 361.38 485.729 363.017 479.279 361.593C479.279 361.593 460.402 368.306 460.653 373.903C460.653 373.903 459.72 375.508 468.191 375.675C476.661 375.842 489.815 376.283 490.181 376.11C490.545 375.938 493.897 373.956 489.895 361.383L489.892 361.38Z",
    fill: "#121729"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M490.179 376.108C489.815 376.28 476.661 375.84 468.188 375.673C459.717 375.505 460.651 373.901 460.651 373.901C460.635 373.532 460.706 373.158 460.844 372.779L491.772 372.633C491.499 375.349 490.38 376.009 490.176 376.108H490.179Z",
    fill: "#83CAF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M508.913 124.333C508.913 124.333 460.041 98.3958 455.108 63.4159L447.935 66.1056C447.935 66.1056 455.557 108.921 492.322 133.93L508.911 124.333H508.913Z",
    fill: "#FFCDC4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.781 197.391H341.449V204.349H368.781V197.391Z",
    fill: "#121729"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.875 197.391H304.543V204.349H331.875V197.391Z",
    fill: "#121729"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.947 197.391H270.615V204.349H297.947V197.391Z",
    fill: "#121729"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.971 202.248H387.101C387.35 202.248 387.555 202.45 387.555 202.702V362.423C387.555 362.672 387.35 362.876 387.101 362.876H251.971C251.722 362.876 251.518 362.672 251.518 362.423V202.702C251.518 202.452 251.722 202.248 251.971 202.248Z",
    fill: "url(#paint8_linear_176_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.119 237.575H376.549C376.849 237.575 377.093 237.819 377.093 238.119V341.881H259.323V238.368C259.323 237.931 259.679 237.573 260.119 237.573V237.575Z",
    fill: "url(#paint9_linear_176_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.244 249.024C301.244 249.024 309.094 245.467 311.563 244.613C314.032 243.759 315.791 241.098 316.74 242.278C317.687 243.461 313.974 246.849 313.974 246.849C313.974 246.849 319.238 247.589 320.891 247.573C322.543 247.554 322.736 248.464 321.787 248.96C320.713 249.52 317.777 250.223 317.777 250.223C317.777 250.223 321.034 249.846 321.373 250.942C321.71 252.035 316.446 253.369 316.446 253.369C316.446 253.369 320.031 253.045 320.54 253.597C321.047 254.146 321.622 255.563 319.026 255.905C316.43 256.244 315.992 256.274 315.992 256.274C315.992 256.274 317.923 256.441 318.482 256.759C319.042 257.077 319.435 258.576 315.536 258.674C311.635 258.772 305.657 257.82 301.66 255.52L301.249 249.027L301.244 249.024Z",
    fill: "#FFCDC4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.378 236.88C259.378 236.88 269.841 250.931 276.118 251.828C282.396 252.724 303.617 248.838 303.617 248.838L305.71 255.117C305.71 255.117 280.489 267.6 266.478 262.592C252.467 257.584 248.916 246.745 248.916 246.745L259.378 236.88Z",
    fill: "#FFCDC4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.519 248.18H298.658C296.589 248.18 294.733 249.456 293.993 251.39L259.325 341.881H377.095L411.749 251.425C412.349 249.86 411.195 248.18 409.519 248.18Z",
    fill: "url(#paint10_linear_176_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.975 265.868H302.819C302.487 265.868 302.172 265.735 301.938 265.502L296.406 259.969C295.921 259.483 295.921 258.693 296.406 258.207C296.891 257.722 297.682 257.722 298.167 258.207L303.336 263.377H407.254L404.252 259.905C403.801 259.385 403.859 258.597 404.379 258.146C404.899 257.698 405.684 257.754 406.137 258.274L410.922 263.807C411.24 264.176 411.314 264.698 411.113 265.141C410.911 265.584 410.468 265.868 409.98 265.868H409.975Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.144 216.676C370.144 214.012 367.986 211.856 365.326 211.856C362.666 211.856 360.507 214.015 360.507 216.676C360.507 219.336 362.666 221.495 365.326 221.495C367.986 221.495 370.144 219.336 370.144 216.676Z",
    fill: "#83CAF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.519 216.676C349.519 214.012 347.361 211.856 344.701 211.856C342.041 211.856 339.882 214.015 339.882 216.676C339.882 219.336 342.041 221.495 344.701 221.495C347.361 221.495 349.519 219.336 349.519 216.676Z",
    fill: "#83CAF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.849 216.676C327.849 214.012 325.69 211.856 323.03 211.856C320.37 211.856 318.209 214.015 318.209 216.676C318.209 219.336 320.368 221.495 323.03 221.495C325.693 221.495 327.849 219.336 327.849 216.676Z",
    fill: "#83CAF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.925 216.676C306.925 214.012 304.766 211.856 302.106 211.856C299.446 211.856 297.287 214.015 297.287 216.676C297.287 219.336 299.446 221.495 302.106 221.495C304.766 221.495 306.925 219.336 306.925 216.676Z",
    fill: "#83CAF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.282 210.062H259.323V224.188H284.282V210.062Z",
    fill: "#83CAF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.801 362.953L269.503 346.29H256.805L256.222 363.868C256.222 363.868 264.019 365.426 266.803 362.953H266.801Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.238 361.871C256.238 361.871 260.253 363.842 266.798 362.953C266.798 362.953 285.06 371.195 284.352 376.752C284.352 376.752 285.151 378.429 276.693 377.898C268.236 377.37 255.09 376.728 254.742 376.524C254.395 376.322 251.218 374.07 256.235 361.868L256.238 361.871Z",
    fill: "#121729"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.745 376.527C255.093 376.728 268.239 377.37 276.696 377.898C285.154 378.426 284.355 376.752 284.355 376.752C284.403 376.386 284.361 376.007 284.255 375.619L253.44 372.935C253.491 375.665 254.552 376.415 254.745 376.529V376.527Z",
    fill: "#83CAF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.709 354.478L189.977 357.401L188.751 345.242L171.704 344.072C171.704 344.072 172.465 352.656 175.711 354.478H175.709Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.277 344.144C173.277 344.144 172.728 348.584 175.712 354.481C175.712 354.481 173.903 374.439 168.421 375.588C168.421 375.588 167.1 376.89 164.83 368.725C162.563 360.561 158.866 347.926 158.943 347.528C159.019 347.133 160.107 343.396 173.277 344.144Z",
    fill: "#121729"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.943 347.526C158.866 347.921 162.563 360.555 164.83 368.723C167.098 376.888 168.421 375.585 168.421 375.585C168.782 375.508 169.126 375.346 169.458 375.118L161.91 345.117C159.348 346.056 158.985 347.308 158.943 347.526Z",
    fill: "#83CAF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.952 237.628C197.952 237.628 188.537 256.913 189.134 286.211L204.977 267.595C204.977 267.595 216.932 247.645 216.932 245.851C216.932 244.058 217.829 230.652 216.932 229.132C216.036 227.612 212.448 223.426 212.448 223.426L197.952 237.628Z",
    fill: "url(#paint11_linear_176_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.454 209.824C238.454 209.824 251.905 219.24 255.268 224.174C258.631 229.108 264.46 240.095 266.478 241.888L252.468 257.584L245.182 249.735L198.777 240.093L189.81 247.716C189.81 247.716 172.771 234.037 173.222 233.702C173.67 233.366 196.854 208.121 203.487 206.009C213.35 202.871 238.46 209.821 238.46 209.821L238.454 209.824Z",
    fill: "url(#paint12_linear_176_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.076 242.56L237.857 284.118C237.857 284.118 273.726 288.304 277.314 299.065C280.903 309.83 272.233 358.86 272.233 358.86H254L257.538 314.901L225.902 309.53C225.902 309.53 239.353 352.282 235.468 358.86C231.582 365.439 179.87 358.86 179.87 358.86V343.613L206.773 341.52C206.773 341.52 185.848 304.448 187.344 287.107C188.839 269.767 209.886 234.965 209.886 234.965L246.079 242.562L246.076 242.56Z",
    fill: "url(#paint13_linear_176_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.307 245.865L212.872 237.883L206.592 260.268L218.961 270.842L235.027 268.25L241.307 245.865Z",
    fill: "#83CAF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.219 245.629C187.219 245.629 179.868 254.669 179.868 257.581C179.868 260.494 196.008 274.547 204.977 276.341L203.184 282.32C203.184 282.32 165.523 275.892 164.327 257.579C164.327 257.579 162.56 249.822 175.102 235.575L187.222 245.623L187.219 245.629Z",
    fill: "#FFCDC4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.963 277.651L218.929 274.439L200.374 291.977L203.409 295.189L221.963 277.651Z",
    fill: "url(#paint14_linear_176_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.501 270.513L223.459 275.279L221.253 272.942L226.249 268.221C224.279 267.173 221.78 267.436 220.067 269.054C217.922 271.083 217.826 274.468 219.855 276.616C221.884 278.762 225.268 278.858 227.416 276.831C229.182 275.163 229.556 272.576 228.506 270.515L228.501 270.513Z",
    fill: "url(#paint15_linear_176_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.591 299.731L202.633 294.964L200.426 292.627L195.432 297.349C194.499 295.322 194.899 292.842 196.612 291.222C198.758 289.192 202.145 289.288 204.173 291.436C206.202 293.582 206.107 296.97 203.959 298.999C202.192 300.667 199.591 300.896 197.591 299.731Z",
    fill: "url(#paint16_linear_176_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.603 189.237C251.603 189.237 253.044 187.789 253.781 188.643C255.661 190.821 252.991 192.6 251.407 192.797L251.606 189.234L251.603 189.237Z",
    fill: "#EDA89D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.33 183.184H253.317C253.359 183.009 253.399 182.836 253.436 182.658C255.001 174.841 249.662 167.244 241.632 166.181C234.941 165.295 228.485 169.47 226.555 175.937C225.839 178.337 225.802 180.749 226.308 182.99C226.931 186.425 227.496 189.367 228.218 191.866C229.411 195.996 229.167 200.41 227.634 204.428L226.427 207.588C233.896 213.71 238.534 210.333 238.534 210.333L239.889 204.362C240.067 203.582 240.81 203.076 241.603 203.182C241.608 203.182 241.613 203.182 241.618 203.182C252.118 204.58 252.402 187.85 253.335 183.178L253.33 183.184Z",
    fill: "#FFCDC4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.889 187.518C238.03 186.818 237.576 186.139 236.876 185.998C236.176 185.858 235.497 186.311 235.357 187.011C235.216 187.712 235.67 188.391 236.37 188.531C237.07 188.672 237.749 188.218 237.889 187.518Z",
    fill: "#121729"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.59 187.518C249.731 186.818 249.278 186.139 248.577 185.998C247.877 185.858 247.198 186.311 247.058 187.011C246.917 187.712 247.371 188.391 248.071 188.531C248.771 188.672 249.45 188.218 249.59 187.518Z",
    fill: "#121729"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.749 184.635C233.619 184.608 233.494 184.547 233.388 184.452C233.078 184.171 233.057 183.693 233.338 183.383C234.187 182.452 236.459 181.213 239.011 183.197C239.34 183.454 239.401 183.929 239.143 184.258C238.886 184.587 238.411 184.645 238.083 184.391C235.987 182.759 234.518 184.332 234.457 184.401C234.272 184.606 234.001 184.685 233.749 184.635Z",
    fill: "#121729"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.016 185.033C245.886 185.006 245.761 184.945 245.655 184.85C245.345 184.568 245.324 184.091 245.605 183.781C246.453 182.849 248.726 181.611 251.277 183.595C251.606 183.852 251.667 184.327 251.41 184.656C251.153 184.985 250.678 185.046 250.349 184.789C248.254 183.157 246.787 184.73 246.724 184.799C246.538 185.003 246.268 185.083 246.016 185.033Z",
    fill: "#121729"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.831 177.908L226.68 187.85H229.252L233.108 176.276L224.831 177.908Z",
    fill: "#121729"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.692 187.635C229.559 187.152 229.244 186.738 228.825 186.462C227.96 185.895 226.387 185.152 225.022 186.062C223.017 187.399 225.491 192.5 229.254 190.964C229.254 190.964 230.392 190.205 229.692 187.635Z",
    fill: "#FFCDC4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.48 193.407C242.146 193.76 241.194 192.887 241.183 192.876C241.093 192.791 241.088 192.651 241.173 192.561C241.258 192.47 241.398 192.465 241.491 192.55C241.536 192.59 242.597 193.547 244.024 192.691C244.257 192.55 244.387 192.425 244.414 192.319C244.451 192.168 244.31 191.937 244.114 191.619C243.663 190.884 242.907 189.651 243.074 187.242C243.082 187.117 243.191 187.025 243.313 187.033C243.438 187.041 243.53 187.149 243.522 187.271C243.363 189.537 244.045 190.645 244.496 191.38C244.74 191.778 244.931 192.091 244.851 192.423C244.793 192.659 244.61 192.86 244.257 193.073C243.987 193.234 243.729 193.34 243.483 193.407H243.48Z",
    fill: "#EDA89D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.908 194.693C237.908 194.693 242.944 196.362 246.522 195.492C246.522 195.492 244.915 199.301 241.852 199.017C238.789 198.733 237.908 194.693 237.908 194.693Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.2 177.462C252.2 177.462 253.879 179.226 252.706 187.579C252.706 187.579 254.587 178.433 253.765 177.215C252.945 175.998 252.197 177.465 252.197 177.465L252.2 177.462Z",
    fill: "#121729"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.59 175.608C253.59 175.608 252.269 163.724 237.974 163.902C223.677 164.08 224.831 177.908 224.831 177.908C224.831 177.908 234.901 175.955 236.93 175.815C238.958 175.674 253.59 175.605 253.59 175.605V175.608Z",
    fill: "url(#paint17_linear_176_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.824 176.531C231.824 176.531 248.866 169.629 258.475 174.289C268.083 178.947 253.889 179.77 253.889 179.77C253.889 179.77 253.224 175.454 231.824 176.531Z",
    fill: "url(#paint18_linear_176_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.805 274.606C199.805 274.606 208.411 275.08 210.997 275.462C213.58 275.847 216.37 274.301 216.664 275.786C216.959 277.272 212.1 278.558 212.1 278.558C212.1 278.558 216.425 281.648 217.9 282.396C219.375 283.144 219.125 284.041 218.054 284.041C216.842 284.041 213.914 283.306 213.914 283.306C213.914 283.306 216.977 284.479 216.77 285.606C216.563 286.731 211.278 285.479 211.278 285.479C211.278 285.479 214.606 286.85 214.802 287.572C214.999 288.293 214.853 289.816 212.392 288.917C209.931 288.017 209.53 287.842 209.53 287.842C209.53 287.842 211.166 288.882 211.514 289.423C211.861 289.964 211.519 291.476 208.016 289.76C204.512 288.044 199.649 284.436 197.169 280.55L199.805 274.603V274.606Z",
    fill: "#FFCDC4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.957 243.164C245.957 243.164 248.691 225.095 248.394 217.402L244.724 214.466C244.724 214.466 243.39 233.559 240.396 242.037L245.954 243.164H245.957Z",
    fill: "url(#paint19_linear_176_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.883 234.965C209.883 234.965 215.046 215.32 213.132 205.285L218.693 205.816C218.693 205.816 219.062 226.418 214.914 238.302L209.883 234.965Z",
    fill: "url(#paint20_linear_176_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.159 359.654C346.47 359.654 345.913 359.097 345.913 358.407V343.125H319.419V357.497C319.419 358.187 318.862 358.744 318.172 358.744C317.483 358.744 316.926 358.187 316.926 357.497V341.881C316.926 341.191 317.483 340.634 318.172 340.634H347.159C347.849 340.634 348.406 341.191 348.406 341.881V358.407C348.406 359.097 347.849 359.654 347.159 359.654Z",
    fill: "#121729"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.888 355.606H360.549V385.824C360.549 386.076 360.345 386.278 360.095 386.278H305.344C305.092 386.278 304.89 386.074 304.89 385.824V355.606H304.888Z",
    fill: "#DB2D7C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.544 354.346H302.894V360.648H362.544V354.346Z",
    fill: "url(#paint21_linear_176_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.818 358.969H322.514V362.877H342.818V358.969Z",
    fill: "url(#paint22_linear_176_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M555.393 163.87C555.393 163.87 557.687 152.583 549.717 208.866L530.554 187.112C530.554 187.112 528.474 163.944 529.254 162.329C530.034 160.713 535.062 148.257 536.531 147.278C538.001 146.302 543.05 144.095 543.05 144.095L555.393 163.867V163.87Z",
    fill: "url(#paint23_linear_176_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M543.978 194.07C543.978 194.07 551.762 191.895 551.72 202.248C551.69 209.439 543.413 354.346 543.413 354.346L525.926 353.499L518.126 244.52L496.809 354.348H477.528L497.623 184.68L543.981 194.073L543.978 194.07Z",
    fill: "url(#paint24_linear_176_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M525.563 120.526C525.563 120.526 518.959 119.179 513.26 119.221C509.147 119.25 497.255 114.876 494.415 113.646L484.4 133.975L503.927 148.684L548.108 165.061L552.863 175.828C552.863 175.828 574.156 170.934 573.899 170.435C573.642 169.936 563.76 137.116 558.708 132.325C551.195 125.203 525.566 120.526 525.566 120.526H525.563Z",
    fill: "url(#paint25_linear_176_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M504.45 146.678L497.032 187.958C497.032 187.958 535.291 227.034 541.491 210.771C547.694 194.51 540.34 155.602 540.34 155.602L504.45 146.678Z",
    fill: "url(#paint26_linear_176_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M556.101 175.072C556.101 175.072 558.785 186.409 557.514 189.035C556.247 191.659 535.598 197.28 526.745 194.99L525.756 201.155C525.756 201.155 562.46 211.768 571.506 195.805C571.506 195.805 576.471 189.592 571.384 171.305L556.101 175.075V175.072Z",
    fill: "#FFCDC4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522.685 96.2657C522.685 96.2657 522.019 94.3373 520.985 94.7829C518.346 95.9235 519.974 98.6902 521.314 99.5576L522.685 96.2657Z",
    fill: "#EDA89D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M523.766 90.0666L523.78 90.0719C523.817 89.8969 523.857 89.7218 523.902 89.5494C525.896 81.8303 534.009 77.3155 541.702 79.8567C548.112 81.9709 552.106 88.5414 551.027 95.2074C550.626 97.6823 549.611 99.868 548.179 101.664C546.123 104.484 544.333 106.889 542.596 108.823C539.724 112.022 538.021 116.102 537.653 120.386L537.363 123.755C527.975 126.015 525.267 120.956 525.267 120.956L526.647 114.99C526.827 114.211 526.376 113.431 525.618 113.181C525.612 113.181 525.607 113.179 525.604 113.176C515.545 109.863 522.573 94.6768 523.764 90.0666H523.766Z",
    fill: "#FFCDC4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M535.781 100.69C535.958 100.001 536.664 99.5841 537.353 99.7645C538.043 99.9422 538.459 100.648 538.282 101.337C538.104 102.027 537.398 102.444 536.709 102.263C536.019 102.086 535.603 101.38 535.783 100.69H535.781Z",
    fill: "#121729"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M525.246 95.5947C525.424 94.905 526.129 94.4885 526.819 94.6689C527.508 94.8466 527.925 95.5522 527.744 96.2419C527.567 96.9316 526.861 97.348 526.172 97.1677C525.482 96.9899 525.066 96.2843 525.246 95.5947Z",
    fill: "#121729"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M540.761 99.8999C540.888 99.9344 541.029 99.9344 541.164 99.8919C541.565 99.7726 541.793 99.3534 541.676 98.9529C541.318 97.746 539.809 95.6398 536.651 96.3136C536.242 96.4011 535.982 96.8043 536.07 97.2128C536.157 97.6213 536.56 97.8813 536.969 97.7937C539.562 97.2367 540.202 99.2924 540.228 99.3826C540.308 99.6479 540.517 99.8362 540.764 99.8999H540.761Z",
    fill: "#121729"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M529.545 94.9156C529.673 94.9501 529.813 94.9501 529.948 94.9077C530.349 94.7883 530.577 94.3692 530.46 93.9687C530.102 92.7617 528.593 90.6555 525.435 91.3293C525.026 91.4168 524.766 91.82 524.854 92.2285C524.941 92.637 525.344 92.897 525.753 92.8095C528.347 92.2551 528.986 94.3082 529.012 94.3984C529.092 94.6636 529.301 94.852 529.548 94.9156H529.545Z",
    fill: "#121729"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M551.719 97.7274L545.728 105.874L543.413 104.754L544.978 92.653L551.719 97.7274Z",
    fill: "#121729"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M543.108 104.367C543.437 103.988 543.901 103.754 544.399 103.69C545.423 103.555 547.163 103.571 547.998 104.985C549.221 107.062 544.773 110.577 542.055 107.555C542.055 107.555 541.36 106.375 543.111 104.367H543.108Z",
    fill: "#FFCDC4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M528.185 103.558C529.233 104.454 530.468 104.083 530.484 104.08C530.601 104.043 530.667 103.919 530.63 103.799C530.593 103.682 530.468 103.614 530.349 103.651C530.291 103.669 528.92 104.067 528.007 102.675C527.859 102.446 527.795 102.279 527.816 102.171C527.848 102.019 528.076 101.873 528.392 101.672C529.118 101.205 530.336 100.425 531.232 98.1837C531.277 98.0669 531.222 97.937 531.108 97.8919C530.993 97.8468 530.861 97.9025 530.816 98.0165C529.972 100.125 528.877 100.828 528.15 101.292C527.758 101.544 527.448 101.743 527.376 102.078C527.326 102.316 527.403 102.576 527.631 102.921C527.803 103.184 527.989 103.393 528.182 103.558H528.185Z",
    fill: "#EDA89D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532.638 107.141C532.638 107.141 527.376 106.449 524.536 104.109C524.536 104.109 524.324 108.24 527.206 109.317C530.089 110.394 532.638 107.141 532.638 107.141Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M527.272 85.4087C527.272 85.4087 524.992 86.2655 522.411 94.2949C522.411 94.2949 524.7 85.2416 525.97 84.5042C527.241 83.7641 527.272 85.4087 527.272 85.4087Z",
    fill: "#121729"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M552.693 94.7882C553.403 94.9103 554.321 94.9368 554.642 94.2895C554.899 93.7696 554.581 93.1675 554.342 92.6396C553.061 89.7828 554.122 86.1381 552.345 83.5624C551.067 81.7082 548.523 80.7851 547.821 78.6445C547.561 77.8487 547.571 76.915 547.015 76.289C546.646 75.8725 546.094 75.6762 545.559 75.5303C543.97 75.0979 542.297 74.9733 540.66 75.1643C540.063 75.2332 539.459 75.3446 538.865 75.2518C537.921 75.1006 537.144 74.4534 536.303 73.9945C535.123 73.3499 533.725 73.0634 532.41 73.3446C531.097 73.6257 529.893 74.5144 529.368 75.7505C529.185 76.1802 529.073 76.6603 528.763 77.0105C528.532 77.2704 528.214 77.4349 527.893 77.5755C527.095 77.9256 526.246 78.159 525.382 78.2731C524.422 78.3978 523.353 78.4057 522.637 79.0583C522.096 79.5517 521.884 80.313 521.815 81.0424C521.695 82.2945 521.979 83.6844 522.958 84.4749C523.942 85.268 525.321 85.2495 526.583 85.3397C527.843 85.4325 529.283 85.8118 529.8 86.9657C530.007 87.4273 530.031 87.9525 530.216 88.422C530.609 89.4114 531.664 89.9923 532.709 90.1913C533.754 90.3902 534.831 90.2894 535.892 90.3451C540.334 90.5812 543.169 93.3664 545.259 96.9846C546.15 98.5258 548.028 100.834 550.083 100.276C552.406 99.6478 552.934 96.8175 552.687 94.7882H552.693Z",
    fill: "#121729"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M504.296 147.273C504.296 147.273 511.128 125.972 514.745 119.179L519.574 119.606C519.574 119.606 510.785 139.745 509.791 148.681L504.296 147.275V147.273Z",
    fill: "url(#paint27_linear_176_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M540.34 155.602C540.34 155.602 544.241 135.667 550.335 127.468L545.097 125.524C545.097 125.524 535.797 143.909 534.359 156.414L540.342 155.602H540.34Z",
    fill: "url(#paint28_linear_176_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.3813 361.593L78.7074 344.762L66.0518 345.804L66.911 363.372C66.911 363.372 74.8088 364.282 77.3813 361.593Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.7679 361.38C66.7679 361.38 70.9316 363.017 77.3814 361.593C77.3814 361.593 96.2587 368.306 96.0095 373.903C96.0095 373.903 96.943 375.508 88.4723 375.675C80.0017 375.842 66.8475 376.283 66.4815 376.11C66.1182 375.938 62.7686 373.956 66.7679 361.383V361.38Z",
    fill: "#121729"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.4819 376.108C66.8452 376.28 79.9994 375.84 88.4727 375.673C96.9433 375.505 96.0125 373.901 96.0125 373.901C96.0284 373.532 95.9568 373.158 95.8189 372.779L64.8906 372.633C65.1638 375.349 66.283 376.009 66.4872 376.108H66.4819Z",
    fill: "#83CAF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.601 361.592L124.53 343.926L112.076 346.149L117.468 362.481C117.468 362.481 125.029 364.282 127.601 361.592Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.985 361.38C116.985 361.38 121.149 363.017 127.598 361.593C127.598 361.593 146.476 368.306 146.226 373.903C146.226 373.903 147.16 375.508 138.689 375.675C130.219 375.842 117.064 376.283 116.698 376.11C116.335 375.938 112.983 373.956 116.985 361.383V361.38Z",
    fill: "#121729"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.698 376.108C117.062 376.28 130.216 375.84 138.689 375.673C147.16 375.505 146.226 373.901 146.226 373.901C146.242 373.532 146.171 373.158 146.033 372.779L115.104 372.633C115.378 375.349 116.497 376.009 116.701 376.108H116.698Z",
    fill: "#83CAF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.9551 163.194C56.9551 163.194 56.8729 184.653 70.165 210.771L76.323 187.112C76.323 187.112 78.4022 163.944 77.6225 162.329C76.8428 160.713 71.8145 148.257 70.3453 147.278C68.8761 146.302 63.8266 144.095 63.8266 144.095L56.9577 163.194H56.9551Z",
    fill: "url(#paint29_linear_176_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.8986 194.07C62.8986 194.07 60.2598 214.731 60.3023 225.084C60.3314 232.275 63.4662 354.346 63.4662 354.346L80.9538 353.499L91.9147 241.902L110.073 354.346H129.354L109.259 184.677L62.9013 194.07H62.8986Z",
    fill: "url(#paint30_linear_176_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.3145 120.526C81.3145 120.526 87.9181 119.179 93.6174 119.221C97.7307 119.25 118.687 131.919 121.528 130.686L115.85 152.36L102.953 148.681L58.772 165.058L54.0169 175.825C54.0169 175.825 32.7236 170.931 32.9808 170.433C33.2381 169.934 43.1196 137.113 48.1718 132.323C55.6851 125.2 81.3145 120.524 81.3145 120.524V120.526Z",
    fill: "url(#paint31_linear_176_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.425 146.678L109.843 187.958C109.843 187.958 71.5842 227.034 65.3837 210.771C59.1806 194.51 66.5347 155.602 66.5347 155.602L102.425 146.678Z",
    fill: "url(#paint32_linear_176_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.1914 96.2657C84.1914 96.2657 84.8571 94.3373 85.8914 94.7829C88.5302 95.9235 86.9018 98.6902 85.5625 99.5576L84.1914 96.2657Z",
    fill: "#EDA89D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.1099 90.0666L83.0966 90.0719C83.0595 89.8969 83.0197 89.7218 82.9746 89.5494C80.9803 81.8303 72.8676 77.3155 65.174 79.8567C58.764 81.9709 54.77 88.5414 55.8494 95.2074C56.2499 97.6823 57.2656 99.868 58.6977 101.664C60.753 104.484 62.5432 106.889 64.2803 108.823C67.1525 112.022 68.8551 116.102 69.2237 120.386L69.5128 123.755C78.901 126.015 81.6088 120.956 81.6088 120.956L80.2297 114.99C80.0494 114.211 80.5002 113.431 81.2587 113.181C81.264 113.181 81.2693 113.179 81.272 113.176C91.3312 109.863 84.3033 94.6768 83.1125 90.0666H83.1099Z",
    fill: "#FFCDC4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.096 100.69C70.9183 100.001 70.2128 99.5841 69.5233 99.7645C68.8338 99.9422 68.4174 100.648 68.5977 101.337C68.7754 102.027 69.4809 102.444 70.1704 102.263C70.8599 102.086 71.2763 101.38 71.0986 100.69H71.096Z",
    fill: "#121729"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.6301 95.5947C81.4525 94.905 80.747 94.4885 80.0575 94.6689C79.3679 94.8466 78.9516 95.5522 79.1319 96.2419C79.3096 96.9316 80.015 97.348 80.7046 97.1677C81.3941 96.9873 81.8105 96.2843 81.6301 95.5947Z",
    fill: "#121729"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.1154 99.8999C65.9881 99.9344 65.8475 99.9344 65.7123 99.8919C65.3118 99.7726 65.0837 99.3534 65.2004 98.9529C65.5585 97.746 67.0675 95.6398 70.2261 96.3136C70.6345 96.4011 70.8944 96.8043 70.8069 97.2128C70.7194 97.6213 70.3162 97.8813 69.9078 97.7937C67.3141 97.2367 66.675 99.2924 66.6485 99.3826C66.5715 99.6479 66.3594 99.8362 66.1127 99.8999H66.1154Z",
    fill: "#121729"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.3283 94.9156C77.201 94.9501 77.0604 94.9501 76.9252 94.9077C76.5247 94.7883 76.2966 94.3692 76.4133 93.9687C76.7714 92.7617 78.2804 90.6555 81.439 91.3293C81.8474 91.4168 82.1073 91.82 82.0198 92.2285C81.9322 92.637 81.5291 92.897 81.1207 92.8095C78.527 92.2551 77.8879 94.3082 77.8613 94.3984C77.7844 94.6636 77.5723 94.852 77.3256 94.9156H77.3283Z",
    fill: "#121729"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.1572 97.7274L61.1482 105.874L63.4635 104.754L61.8987 92.653L55.1572 97.7274Z",
    fill: "#DB2D7C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.7655 104.367C63.4367 103.988 62.9725 103.754 62.474 103.69C61.4503 103.555 59.7105 103.571 58.8751 104.985C57.6525 107.062 62.1 110.577 64.8184 107.555C64.8184 107.555 65.5132 106.375 63.7629 104.367H63.7655Z",
    fill: "#FFCDC4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.6911 103.558C77.6435 104.454 76.4076 104.083 76.3944 104.08C76.275 104.043 76.2114 103.919 76.2485 103.799C76.2856 103.682 76.4103 103.614 76.5296 103.651C76.588 103.669 77.9591 104.067 78.8714 102.675C79.0199 102.446 79.0836 102.279 79.0623 102.171C79.0305 102.019 78.8024 101.873 78.4869 101.672C77.7602 101.205 76.5429 100.425 75.6465 98.1837C75.6014 98.0669 75.6571 97.937 75.7711 97.8919C75.8852 97.8468 76.0178 97.9025 76.0629 98.0165C76.9062 100.125 78.0015 100.828 78.7282 101.292C79.1207 101.544 79.431 101.743 79.5026 102.078C79.553 102.316 79.4761 102.576 79.248 102.921C79.0756 103.184 78.89 103.393 78.6964 103.558H78.6911Z",
    fill: "#EDA89D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.2363 107.141C74.2363 107.141 79.498 106.449 82.3383 104.109C82.3383 104.109 82.5505 108.24 79.6677 109.317C76.7849 110.394 74.2363 107.141 74.2363 107.141Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.6016 85.4087C79.6016 85.4087 81.8823 86.2655 84.4628 94.2949C84.4628 94.2949 82.1741 85.2416 80.9037 84.5042C79.6334 83.7641 79.6016 85.4087 79.6016 85.4087Z",
    fill: "#DB2D7C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.581 147.273C102.581 147.273 95.7495 125.972 92.1321 119.179L87.3027 119.606C87.3027 119.606 96.0916 139.745 97.0862 148.681L102.581 147.275V147.273Z",
    fill: "url(#paint33_linear_176_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.6006 262.881C54.9111 262.881 54.3541 262.324 54.3541 261.634V246.353H27.8601V260.722C27.8601 261.412 27.3032 261.969 26.6137 261.969C25.9241 261.969 25.3672 261.412 25.3672 260.722V245.106C25.3672 244.416 25.9241 243.859 26.6137 243.859H55.6006C56.2901 243.859 56.8471 244.416 56.8471 245.106V261.632C56.8471 262.322 56.2901 262.879 55.6006 262.879V262.881Z",
    fill: "#121729"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3291 258.833H68.9904V289.153C68.9904 289.349 68.8313 289.505 68.6377 289.505H13.6845C13.4882 289.505 13.3318 289.346 13.3318 289.153V258.833H13.3291Z",
    fill: "#DB2D7C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.9849 257.573H11.335V263.876H70.9849V257.573Z",
    fill: "url(#paint34_linear_176_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.2611 262.197H30.957V266.104H51.2611V262.197Z",
    fill: "url(#paint35_linear_176_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.5376 155.602C66.5376 155.602 62.6364 135.667 56.542 127.468L61.7798 125.524C61.7798 125.524 71.0779 143.909 72.518 156.414L66.5349 155.602H66.5376Z",
    fill: "url(#paint36_linear_176_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.2526 229.331C44.2526 229.331 46.8595 237.549 47.4165 240.101C47.9734 242.655 50.408 244.713 49.1217 245.517C47.8355 246.318 44.9103 242.231 44.9103 242.231C44.9103 242.231 43.7301 245.729 43.5551 247.371C43.3774 249.016 41.9161 249.345 41.5369 248.342C41.1072 247.207 41.1152 245.61 41.1152 245.61C41.1152 245.61 41.1046 248.891 39.9775 249.096C38.853 249.302 38.1502 243.915 38.1502 243.915C38.1502 243.915 38.0468 247.515 37.4421 247.955C36.8374 248.393 35.3629 248.798 35.3311 246.178C35.2992 243.557 35.3205 243.122 35.3205 243.122C35.3205 243.122 34.8882 246.393 34.5063 246.91C34.1244 247.427 32.6286 246.268 32.992 242.382C33.3553 238.496 35.6387 232.511 38.3942 228.814L44.2552 229.331H44.2526Z",
    fill: "#FFCDC4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.212 0C453.756 0.0769256 452.544 0.175072 451.329 0.286481V58.8719H455.212V0Z",
    fill: "url(#paint37_linear_176_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.54 49.9459H489.039C495.791 49.9459 501.273 55.4289 501.273 62.1824V66.0419C501.273 72.0262 496.414 76.8858 490.431 76.8858H412.148C406.162 76.8858 401.304 72.0262 401.304 66.0393V62.1824C401.304 55.4289 406.786 49.9459 413.538 49.9459H413.54Z",
    fill: "url(#paint38_linear_176_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.561 52.2033H258.79C263.034 52.2033 266.476 55.6491 266.476 59.8906V93.3293C266.476 97.5735 263.031 101.017 258.79 101.017H158.996C146.235 101.017 135.873 90.6529 135.873 77.8885V59.8879C135.873 55.6438 139.318 52.2007 143.559 52.2007L143.561 52.2033Z",
    fill: "url(#paint39_linear_176_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.163 89.3027C148.128 94.5443 154.395 97.9449 161.47 97.9449H242.072C244.583 97.9449 246.62 95.9077 246.62 93.3957V89.3027H144.163Z",
    fill: "#121729"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.828 83.9948H142.824C142.48 83.9948 142.201 83.7162 142.201 83.3714C142.201 83.0266 142.48 82.748 142.824 82.748H244.828C245.172 82.748 245.451 83.0266 245.451 83.3714C245.451 83.7162 245.172 83.9948 244.828 83.9948Z",
    fill: "#83CAF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.828 79.2864H142.824C142.48 79.2864 142.201 79.0079 142.201 78.663C142.201 78.3182 142.48 78.0397 142.824 78.0397H244.828C245.172 78.0397 245.451 78.3182 245.451 78.663C245.451 79.0079 245.172 79.2864 244.828 79.2864Z",
    fill: "#83CAF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.828 56.6888C244.828 55.6358 243.974 54.7816 242.923 54.7816C241.873 54.7816 241.017 55.6358 241.017 56.6888C241.017 57.7419 241.871 58.5961 242.923 58.5961C243.976 58.5961 244.828 57.7419 244.828 56.6888Z",
    fill: "#DB2D7C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.428 56.6888C237.428 55.6358 236.574 54.7816 235.524 54.7816C234.474 54.7816 233.617 55.6358 233.617 56.6888C233.617 57.7419 234.471 58.5961 235.524 58.5961C236.577 58.5961 237.428 57.7419 237.428 56.6888Z",
    fill: "#121729"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.5825 89.3026C67.5289 89.9234 70.7909 90.048 73.7984 89.8915C74.6232 89.8491 75.4798 89.7642 76.1826 89.3318C76.7528 88.979 77.1824 88.1541 76.7315 87.6554C76.5963 87.5042 76.4053 87.4166 76.217 87.3371C75.0926 86.8569 73.9151 86.4962 72.711 86.2654C75.2517 86.3397 77.7977 86.3211 80.3383 86.2097C81.6988 86.1487 83.2052 85.9948 84.1149 84.9789C84.815 84.1964 84.9847 83.0266 84.7036 82.0133C84.4251 81 83.7489 80.1326 82.9506 79.4482C80.1845 77.0821 76.2038 76.8725 72.5705 77.0768C73.4801 75.8035 74.0715 74.3022 74.2731 72.7504C74.3235 72.3631 74.342 71.936 74.1193 71.6151C73.9522 71.371 73.6737 71.2278 73.3953 71.1296C71.5017 70.4506 69.4331 71.379 67.7066 72.4135C65.6088 73.6708 63.6065 75.1404 62.0126 76.9946C60.4161 78.8487 59.2386 81.1194 58.9522 83.5491C59.0874 82.321 59.2227 81.0928 59.3579 79.8647C59.4296 79.2095 59.4667 78.4482 58.984 77.9999C58.5093 77.5542 57.7004 77.6497 57.1965 78.0609C56.6926 78.4721 56.4354 79.114 56.2789 79.7453C55.8201 81.6048 56.0694 83.6314 56.9684 85.3211C54.335 85.4564 51.9667 87.6845 51.667 90.3027C52.5607 90.4167 53.4757 90.3451 54.3403 90.0984C53.7356 91.4486 53.3563 92.8996 53.2184 94.3718C53.1548 95.0694 53.1442 95.7803 53.3033 96.4647C53.603 97.7698 54.5392 98.913 55.7565 99.4674C56.9764 100.022 58.4509 99.9741 59.6311 99.3428C61.3921 98.4011 62.2832 96.4169 63.0523 94.5734C63.7736 92.8465 63.8532 91.0321 64.5745 89.3053L64.5825 89.3026Z",
    fill: "#DB2D7C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.782 105.77C186.527 103.998 183.233 102.924 183.299 101.144C183 100.157 182.716 99.1649 182.485 98.157C182.345 97.5362 182.286 96.9261 182.276 96.3214C180.541 97.2285 177.64 98.409 177.64 98.409C177.64 98.409 183.782 92.8438 182.209 92.2072C180.637 91.5705 176.009 95.3558 174.062 97.5389C172.116 99.7246 166.804 106.945 166.804 106.945L170.97 113.118C175.555 113.173 180.719 111.425 184.45 109.473C184.002 108.523 186.93 106.812 186.779 105.77H186.782Z",
    fill: "#FFCDC4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.546 86.2678L177.797 86.2096L177.947 87.9032H183.001L185.077 82.8226H189.557V80C189.557 80 181.347 80 180.294 80C179.241 80 178.594 80.6825 178.594 80.6825C178.594 80.6825 175.36 83.8653 174.432 84.6973C172.864 86.1036 174.546 86.2678 174.546 86.2678Z",
    fill: "#4D506E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.121 82.5054L191.815 82.0464V80.953L190.121 80.3529V82.5054Z",
    fill: "#4D506E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.911 88.4678H177.137V90.7258H183.911V88.4678Z",
    fill: "#4D506E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.734 105.05C186.734 99.8992 183.951 98.676 183.651 98.3937C183.35 98.1113 183.154 97.8494 183.154 97.2849C183.154 96.7204 183.911 96.3004 183.911 95.7122C183.911 94.6774 183.185 94.5131 183.185 94.0192C183.185 93.1719 183.818 93.1984 183.818 92.4928C183.818 91.5257 183.187 91.2903 183.187 91.2903C183.187 91.2903 178.499 91.2553 177.447 91.2903C173.115 98.2762 173.186 105.403 173.186 105.403C173.186 105.403 173.186 111.472 173.186 113.165C173.186 114.859 174.007 115 174.007 115C174.007 115 185.197 115 186.039 115C186.881 115 186.734 113.871 186.734 113.871C186.734 113.871 186.734 112.036 186.734 105.05Z",
    fill: "#4D506E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.534 89.5968C188.967 86.9538 188.927 83.3871 188.927 83.3871H185.839C186.481 87.1507 188.843 89.1768 190.428 90.1263C191.253 90.6202 191.53 90.5485 191.661 90.3797C191.995 89.9496 191.534 89.5968 191.534 89.5968Z",
    fill: "#4D506E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.503 95.5018C183.503 95.5018 176.836 99.6054 177.292 100.613C177.748 101.621 183.636 99.624 183.559 99.6903C183.482 99.7539 177.692 102.85 177.83 104.396C177.968 105.942 184.641 103.34 184.641 103.34C184.641 103.34 179 105.847 179.154 106.9C179.307 107.953 184.97 106.147 185.105 106.531C185.24 106.919 180.257 108.104 180.39 109.42C180.522 110.736 187.614 109.332 188.144 107.935C188.675 106.537 187.394 105.704 187.394 105.704C187.394 105.704 188.025 103.263 186.969 102.372C186.969 102.372 186.587 98.9475 185.062 98.8202C185.062 98.8202 185.983 95.9474 183.508 95.4991L183.503 95.5018Z",
    fill: "#EDA89D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.8394 153.833L70.749 158.936L74.7642 181.836L90.4909 186.019L103.855 176.735L99.8394 153.833Z",
    fill: "#83CAF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M537.369 160.308L508.483 154.154L503.641 176.894L516.66 186.659L532.527 183.048L537.369 160.308Z",
    fill: "#83CAF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518.196 175.579C516.941 171.34 512.205 169.008 507.617 170.366C503.029 171.724 500.326 176.263 501.581 180.499C502.188 182.555 503.617 184.162 505.45 185.117C507.11 185.982 508.359 187.473 508.89 189.269C509.319 190.722 510.847 191.55 512.297 191.12L514.987 190.324C516.44 189.895 517.267 188.367 516.838 186.916C516.307 185.12 516.543 183.192 517.464 181.56C518.479 179.762 518.803 177.634 518.196 175.579Z",
    fill: "#DB2D7C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M515.382 191.248C515.332 191.263 515.276 191.234 515.258 191.184C514.958 190.343 512.298 176.595 512.186 176.011C512.176 175.955 512.21 175.902 512.266 175.892C512.322 175.881 512.375 175.918 512.385 175.971C512.415 176.114 515.154 190.287 515.448 191.115C515.467 191.168 515.441 191.226 515.387 191.245C515.387 191.245 515.385 191.245 515.382 191.245V191.248Z",
    fill: "#121729"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M512.395 192.131C512.395 192.131 512.393 192.131 512.39 192.131C512.334 192.144 512.281 192.11 512.268 192.057C512.064 191.202 506.648 177.82 506.595 177.685C506.574 177.632 506.601 177.573 506.651 177.552C506.704 177.531 506.762 177.555 506.784 177.608C507.006 178.16 512.26 191.139 512.467 192.009C512.48 192.062 512.448 192.115 512.398 192.131H512.395Z",
    fill: "#121729"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M510.247 180.308C509.995 180.383 509.703 180.372 509.438 180.266C509.313 180.425 509.146 180.552 508.937 180.595C508.653 180.653 508.327 180.542 508.07 180.298C507.847 180.088 507.359 179.295 507.21 179.016C507.197 178.993 507.205 178.961 507.232 178.947C507.255 178.934 507.287 178.942 507.301 178.969C507.457 179.258 507.937 180.03 508.141 180.223C508.375 180.444 508.666 180.544 508.918 180.494C509.093 180.459 509.237 180.356 509.345 180.223C508.892 180.003 508.621 179.581 508.475 179.268C508.292 178.876 508.245 178.518 508.33 178.207C508.369 178.064 508.436 177.953 508.526 177.881C508.754 177.695 509.112 177.791 509.303 177.998C509.491 178.202 509.56 178.475 509.613 178.741C509.682 179.069 509.746 179.451 509.661 179.815C509.632 179.937 509.579 180.064 509.504 180.181C509.87 180.316 510.276 180.266 510.544 180.043C510.658 179.95 510.748 179.825 510.812 179.682C510.666 179.645 510.536 179.571 510.438 179.462C510.327 179.337 510.263 179.184 510.21 179.035C510.051 178.589 509.969 178.125 509.961 177.65C509.961 177.634 509.969 177.616 509.982 177.608C510.12 177.512 510.303 177.56 510.414 177.642C510.528 177.73 510.602 177.855 510.666 177.979C510.817 178.268 510.992 178.656 511.019 179.064C511.032 179.255 511.008 179.441 510.952 179.608C511.141 179.629 511.345 179.587 511.512 179.475C511.602 179.414 511.682 179.337 511.751 179.247C511.653 179.165 511.573 179.069 511.517 178.993C511.064 178.377 510.854 177.587 510.942 176.825C510.942 176.812 510.95 176.799 510.963 176.791C511.151 176.656 511.411 176.719 511.568 176.855C511.729 176.992 511.817 177.194 511.883 177.374C512.003 177.685 512.135 178.099 512.109 178.528C512.093 178.788 512.016 179.03 511.891 179.226C512.008 179.306 512.146 179.359 512.292 179.329C512.414 179.303 512.504 179.229 512.56 179.168C512.756 178.961 512.806 178.621 512.684 178.367C512.674 178.34 512.684 178.311 512.708 178.298C512.735 178.284 512.764 178.298 512.777 178.321C512.92 178.619 512.862 178.995 512.636 179.237C512.541 179.337 512.43 179.404 512.313 179.428C512.133 179.465 511.971 179.404 511.833 179.308C511.759 179.406 511.668 179.491 511.57 179.558C511.377 179.688 511.138 179.735 510.918 179.703C510.849 179.871 510.746 180.014 510.613 180.123C510.51 180.207 510.388 180.271 510.258 180.308H510.247ZM508.701 177.9C508.658 177.913 508.619 177.932 508.584 177.961C508.513 178.019 508.457 178.112 508.422 178.234C508.343 178.518 508.393 178.86 508.563 179.226C508.701 179.523 508.958 179.924 509.385 180.133C509.39 180.136 509.398 180.138 509.404 180.141C509.475 180.032 509.528 179.91 509.555 179.791C509.637 179.446 509.573 179.08 509.507 178.762C509.457 178.512 509.39 178.252 509.221 178.067C509.093 177.929 508.876 177.847 508.701 177.9ZM510.056 177.68C510.067 178.13 510.149 178.576 510.3 179.001C510.348 179.138 510.409 179.282 510.51 179.393C510.597 179.489 510.714 179.555 510.844 179.587C510.897 179.43 510.921 179.253 510.91 179.069C510.886 178.68 510.714 178.306 510.568 178.024C510.51 177.913 510.446 177.796 510.348 177.722C510.268 177.664 510.146 177.632 510.056 177.677V177.68ZM511.032 176.86C510.955 177.587 511.159 178.34 511.592 178.932C511.634 178.99 511.708 179.08 511.801 179.16C511.912 178.979 511.984 178.756 511.997 178.518C512.021 178.107 511.894 177.709 511.78 177.406C511.716 177.239 511.637 177.051 511.493 176.929C511.374 176.828 511.175 176.77 511.032 176.857V176.86Z",
    fill: "#121729"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518.14 193.974L511.642 195.898C511.592 195.913 511.539 195.884 511.526 195.834L510.987 194.017L517.665 192.041L518.204 193.858C518.219 193.908 518.19 193.961 518.14 193.974Z",
    fill: "#424BE1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M515.011 193.831C513.043 194.415 511.128 194.372 511.006 194.367C510.64 194.356 510.351 194.051 510.362 193.685C510.372 193.319 510.677 193.03 511.043 193.041C511.107 193.041 515.077 193.12 517.01 191.311C517.278 191.062 517.697 191.075 517.949 191.343C518.198 191.611 518.185 192.03 517.917 192.279C517.108 193.035 516.053 193.521 515.011 193.829V193.831Z",
    fill: "#121729"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M514.703 192.797C512.735 193.38 510.82 193.338 510.698 193.332C510.332 193.322 510.043 193.017 510.054 192.651C510.065 192.285 510.37 191.996 510.736 192.006C510.799 192.006 514.769 192.086 516.703 190.277C516.971 190.027 517.39 190.041 517.639 190.309C517.888 190.576 517.875 190.996 517.607 191.245C516.798 192.001 515.743 192.486 514.7 192.794L514.703 192.797Z",
    fill: "#424BE1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M514.397 191.762C512.43 192.346 510.515 192.303 510.393 192.298C510.027 192.287 509.738 191.982 509.748 191.616C509.759 191.25 510.064 190.961 510.43 190.972C510.494 190.972 514.464 191.051 516.397 189.242C516.665 188.993 517.084 189.006 517.336 189.274C517.585 189.542 517.572 189.961 517.304 190.21C516.495 190.966 515.44 191.452 514.397 191.759V191.762Z",
    fill: "#121729"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M530.063 196.227C530.063 196.227 522.537 192.025 520.147 190.966C517.758 189.908 516.227 187.11 515.185 188.208C514.143 189.306 517.561 192.993 517.561 192.993C517.561 192.993 512.255 193.29 510.608 193.134C508.963 192.977 508.693 193.868 509.597 194.441C510.621 195.089 513.488 196.036 513.488 196.036C513.488 196.036 510.273 195.388 509.844 196.449C509.417 197.51 514.551 199.28 514.551 199.28C514.551 199.28 511.005 198.659 510.454 199.163C509.902 199.67 509.213 201.033 511.772 201.59C514.331 202.147 514.763 202.213 514.763 202.213C514.763 202.213 512.825 202.219 512.241 202.489C511.658 202.76 511.141 204.222 515.018 204.646C518.895 205.07 525.218 204.031 529.389 202.073L530.058 196.227H530.063Z",
    fill: "#FFCDC4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_176_2",
    x1: 356.924,
    y1: 277.386,
    x2: 491.765,
    y2: 277.386,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A998F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CDC5FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_176_2",
    x1: 357.099,
    y1: 269.86,
    x2: 479.398,
    y2: 269.86,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4E1FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CDC5FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_176_2",
    x1: 376.745,
    y1: 264.974,
    x2: 480.021,
    y2: 264.974,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4E1FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CDC5FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_176_2",
    x1: 425.511,
    y1: 256.528,
    x2: 489.06,
    y2: 256.528,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4E1FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CDC5FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_176_2",
    x1: 398.982,
    y1: 284.15,
    x2: 404.902,
    y2: 284.15,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4E1FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CDC5FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_176_2",
    x1: 479.647,
    y1: 317.05,
    x2: 602,
    y2: 317.05,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4E1FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CDC5FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_176_2",
    x1: 483.209,
    y1: 317.509,
    x2: 602,
    y2: 317.509,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A998F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CDC5FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_176_2",
    x1: 0,
    y1: 384.201,
    x2: 587.941,
    y2: 384.201,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4E1FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CDC5FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_176_2",
    x1: 319.537,
    y1: 362.876,
    x2: 319.537,
    y2: 202.248,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A998F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CDC5FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_176_2",
    x1: 259.323,
    y1: 289.728,
    x2: 377.093,
    y2: 289.728,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#606386"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A1D2D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_176_2",
    x1: 335.617,
    y1: 341.881,
    x2: 335.617,
    y2: 248.18,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CDC5FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A998F8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_176_2",
    x1: 203.219,
    y1: 286.211,
    x2: 203.219,
    y2: 223.426,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8B2682"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DB2D88"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_176_2",
    x1: 219.842,
    y1: 257.584,
    x2: 219.842,
    y2: 205.198,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8B2682"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DB2D88"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_176_2",
    x1: 229.026,
    y1: 361.784,
    x2: 229.026,
    y2: 234.965,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E1F87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6E32F9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_176_2",
    x1: 211.176,
    y1: 295.184,
    x2: 211.176,
    y2: 274.433,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#606386"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A1D2D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_176_2",
    x1: 223.738,
    y1: 278.29,
    x2: 223.738,
    y2: 267.595,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#606386"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A1D2D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_176_2",
    x1: 200.286,
    y1: 300.461,
    x2: 200.286,
    y2: 289.763,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#606386"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A1D2D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_176_2",
    x1: 239.2,
    y1: 177.908,
    x2: 239.2,
    y2: 163.899,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8B2682"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DB2D88"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_176_2",
    x1: 246.816,
    y1: 179.77,
    x2: 246.816,
    y2: 172.671,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8B2682"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DB2D88"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_176_2",
    x1: 244.405,
    y1: 243.164,
    x2: 244.405,
    y2: 214.466,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6E32F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E1F87"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_176_2",
    x1: 214.291,
    y1: 238.299,
    x2: 214.291,
    y2: 205.283,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6E32F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E1F87"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_176_2",
    x1: 332.719,
    y1: 360.648,
    x2: 332.719,
    y2: 354.346,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8B2682"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DB2D88"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_176_2",
    x1: 332.666,
    y1: 362.877,
    x2: 332.666,
    y2: 358.969,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8B2682"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DB2D88"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_176_2",
    x1: 542.39,
    y1: 208.866,
    x2: 542.39,
    y2: 144.098,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8B2682"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DB2D88"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_176_2",
    x1: 514.623,
    y1: 354.346,
    x2: 514.623,
    y2: 184.677,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E1F87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6E32F9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_176_2",
    x1: 529.151,
    y1: 175.825,
    x2: 529.151,
    y2: 113.643,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8B2682"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DB2D88"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_176_2",
    x1: 520.506,
    y1: 214.731,
    x2: 520.506,
    y2: 146.678,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6E32F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E1F87"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_176_2",
    x1: 511.934,
    y1: 148.681,
    x2: 511.934,
    y2: 119.179,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E1F87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6E32F9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_176_2",
    x1: 542.347,
    y1: 156.414,
    x2: 542.347,
    y2: 125.521,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E1F87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6E32F9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_176_2",
    x1: 67.375,
    y1: 210.771,
    x2: 67.375,
    y2: 144.098,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8B2682"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DB2D88"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_176_2",
    x1: 94.824,
    y1: 354.346,
    x2: 94.824,
    y2: 184.677,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E1F87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6E32F9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_176_2",
    x1: 77.2515,
    y1: 175.825,
    x2: 77.2515,
    y2: 119.219,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8B2682"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DB2D88"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_176_2",
    x1: 86.372,
    y1: 0.00000974258,
    x2: 86.372,
    y2: 146.678,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6E32F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E1F87"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_176_2",
    x1: 94.9406,
    y1: 148.681,
    x2: 94.9406,
    y2: 119.179,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E1F87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6E32F9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_176_2",
    x1: 41.1599,
    y1: 263.876,
    x2: 41.1599,
    y2: 257.573,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8B2682"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DB2D88"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_176_2",
    x1: 41.1091,
    y1: 266.104,
    x2: 41.1091,
    y2: 262.197,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8B2682"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DB2D88"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_176_2",
    x1: 64.53,
    y1: 156.414,
    x2: 64.53,
    y2: 125.521,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E1F87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6E32F9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_176_2",
    x1: 453.27,
    y1: 58.8746,
    x2: 453.27,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A998F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CDC5FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_176_2",
    x1: 451.29,
    y1: 76.8858,
    x2: 451.29,
    y2: 49.9459,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A998F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CDC5FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_176_2",
    x1: 201.175,
    y1: 101.019,
    x2: 201.175,
    y2: 52.2033,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A998F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CDC5FC"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_176_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 602,
    height: 411,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeroart4);
export default __webpack_public_path__ + "static/media/heroart-4.ec665fe7b083d1ffdd8a4e7c3fce9db4.svg";
export { ForwardRef as ReactComponent };